import EndPoints from "../EndPoints";
import Request from "../Request";
import Methods from "../Methods";
export default function unregisterUser(data, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = EndPoints.USER_UNREGISTER;
    var request = new Request({
        method: Methods.POST,
        url: url,
        data: data,
        withCredentials: true,
        blockUI: blockUI,
        headers: { "Content-Type": "application/json" },
    });
    return request.execute();
}
